const PageLoader = () => (
  <div
    data-testid="page-loader"
    className="min-h-screen flex items-center justify-center bg-[#f7f7f8]"
  >
    <div className="flex flex-col items-center gap-3">
      <div className="w-10 h-10 rounded-full border-2 border-[#7119AF]/20 border-t-[#7119AF] animate-spin" />
      <p className="text-xs text-gray-400 uppercase tracking-[0.2em] font-semibold">Loading</p>
    </div>
  </div>
);

export default PageLoader;
